import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function HTMLSnippet({
	snippet,
	delay = 0,
	callback = () => {},
}) {
	const ref = useRef(null);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		// Re-create <script> nodes so the browser executes them
		// (innerHTML-injected scripts never run).
		el.querySelectorAll('script').forEach((old) => {
			const s = document.createElement('script');
			[...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
			s.textContent = old.textContent;
			old.replaceWith(s);
		});
	}, [snippet]);

	useEffect(() => {
		const id = setTimeout(callback, delay);
		return () => clearTimeout(id);
	}, []);

	return (
		<div
			ref={ref}
			dangerouslySetInnerHTML={{ __html: snippet }}
		/>
	);
}

export default HTMLSnippet;

HTMLSnippet.propTypes = {
	snippet: PropTypes.string.isRequired,
	delay: PropTypes.number,
	callback: PropTypes.func,
};
